export default function moreInfoToggle() {

    const moreInfoTriggers = document.querySelectorAll('.js-more-info-toggle')

    if (!moreInfoTriggers) {
        return
    }

    Array.prototype.forEach.call(moreInfoTriggers, trigger => {

        let btn = trigger
        let target = trigger.getAttribute('data-target')

        btn.onclick = () => {
            let expanded = btn.getAttribute('aria-expanded') === 'true'
            btn.setAttribute('aria-expanded', !expanded)
            document.getElementById(target).hidden = expanded
        }

    })

}
